module.exports = __webpack_public_path__ + "img/logoblack.9f322a86.png";